import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

export const getEntitlementsApi = async (authHeaders) => {
    const apiInputData = {
        operation: "GET_USER_ENTITLEMENTS"
    };
    try {
        const res = await apiCallPost(apiPaths.entitlements, apiInputData, authHeaders);
        if (res) {
            return { data: res, status: true };
        }
        return { data: {}, status: false, errMsg: 'Failed to fetch entitlements' };
    } catch (err) {
        return { status: false, errMsg: err.message };
    }
}
